// extracted by mini-css-extract-plugin
export default {"activtyPage_container":"UserDevicesPage_activtyPage_container__JI+ol"};